import { render } from "./WellTypeCountChart.vue?vue&type=template&id=0f2b7de8&ts=true"
import script from "./WellTypeCountChart.vue?vue&type=script&lang=ts"
export * from "./WellTypeCountChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../build_modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__